import { render, staticRenderFns } from "./AdvertisingManage.vue?vue&type=template&id=190024c6&scoped=true"
import script from "./AdvertisingManage.vue?vue&type=script&lang=js"
export * from "./AdvertisingManage.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingManage.vue?vue&type=style&index=0&id=190024c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190024c6",
  null
  
)

export default component.exports